import "../../../features/BuyerFlow/campaigndetailspage/CampaignDetailsPage.css";
import { ReactComponent as Arrow } from "../../../assests/Icon_transform.svg";
import { ReactComponent as Duplicate } from "../../../assests/duplicate-icon.svg";
import { ReactComponent as AddProduct } from "../../../assests/add-producticon.svg";
import { ReactComponent as Delete } from "../../../assests/delete_icon.svg";
import { ReactComponent as Share } from "../../../assests/share-icon.svg";
import {
  Row,
  Divider,
  Col,
  Drawer,
  Space,
  Typography,
  Tooltip,
  Button,
  Modal,
} from "../../common/utils/antd-imports/AntdImports";
import { useMediaQuery } from "react-responsive";
import { ReactComponent as CartIcon } from "../../../assests/cart-icon.svg";
import { ReactComponent as DotsIcon } from "../../../assests/dots-icon.svg";
import { ReactComponent as ExcelIcon } from "../../../assests/export-excel-icon.svg";
import ShareCampaign from "../../modal/share-campaign-modal/ShareCampaign";
import { useState } from "react";
import DuplicateCampaign from "../../modal/duplicate-campaign/DuplicateCampaign";
import DeleteCamapign from "../../modal/delete-campaign/DeleteCampaign";
import { Outlet, useNavigate } from "react-router-dom";
import "./CampaignOverview.css";
import ViewTermsPlan from "../../modal/view-payment-terms/ViewTermsPlan";
import { addBreadcrumb } from "../../../store/slices/common-slice/bread-crumbs/BreadCrumbSlice";
import { useDispatch } from "react-redux";
import { CopyOutlined } from "@ant-design/icons";
import { handleCopy } from "../utils/Utils";

const CampaignOverview = ({
  campaignInfo,
  onUpdateState,
  handleAddtoCart,
  handleOfferModal,
  handleGrossFee,
  handleViewRfp,
  hideButton,
  offerTooltip,
  getToolTipContent,
  customTermsApplied,
  setTransferCampaignFlag,
}) => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const dispatch = useDispatch();
  const { Text } = Typography;
  const [menu, setMenu] = useState(false);
  const [shareCampaign, setShareCampaign] = useState(false);
  const [duplicateCampaign, setDuplicateCampaign] = useState(false);
  const [deleteCampaignModal, setDeleteCampaignModal] = useState(false);
  const [viewTermsModal, setViewTermsModal] = useState(false);
  const userInfo = JSON.parse(localStorage.getItem("user"))?.user;
  const navigate = useNavigate();
  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp); // works for ISO strings
    if (isNaN(date.getTime())) return "";
    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    }).format(date);
  };
  const tooltipContent = getToolTipContent?.();
  const shouldShowTooltip =
    tooltipContent &&
    tooltipContent !==
      "You cannot perform this action, when it is already in cart";
  const handleShareCampaign = () => {
    setShareCampaign(true);
  };

  const goToSubPage = ({ title, path }) => {
    dispatch(
      addBreadcrumb({
        title,
        path,
      }),
    );
  };
  const handleQoute = () => {
    onUpdateState({
      openDialog: true,
      isQuote: true,
      ioPrint: false,
    });
  };

  const handleIO = () => {
    onUpdateState({
      openDialog: true,
      isQuote: false,
      ioPrint: true,
    });
  };

  const handleAddCampaign = () => {
    localStorage.setItem("campaignId", campaignInfo?.id);
    localStorage.setItem("CampaignName", campaignInfo?.name);
    localStorage.setItem("campaignFlag", 1);
    goToSubPage({ title: "Shop", path: "/buyer/products" });
    navigate("/buyer/products", {
      state: { campaignId: campaignInfo?.id, from: "/campaigns-page" },
    });
  };
  const handleDuplicateCampaign = () => {
    setDuplicateCampaign(true);
  };
  const handleDeleteCampaign = () => {
    setDeleteCampaignModal(true);
  };
  const handleTermsHistory = () => {
    setViewTermsModal(true);
  };
  const restrictClick = () => {
    if (
      hideButton ||
      offerTooltip ||
      campaignInfo?.status === 600 ||
      campaignInfo?.checkout_checked == 1 ||
      campaignInfo?.status === 700 ||
      campaignInfo?.status === 800 ||
      campaignInfo?.status === 1000 ||
      campaignInfo?.status === 1200
    )
      return true;
    else return false;
  };
  const restrictOfferClick = () => {
    return restrictClick() || !campaignInfo?.products_in_campaign;
  };
  const deleteCampaignButton = (
    <div
      className={`campaign-overview-actions ${
        restrictClick() ? "disable-button" : "pointer"
      }`}
      onClick={() => {
        if (!restrictClick()) handleDeleteCampaign();
      }}
    >
      <Delete
        className="campaign-action-icons"
        style={{ color: restrictClick() ? "#808080" : "#d2042d" }}
      />
      <span
        className={`campaign-overview-actions-headers  ${restrictClick() ? "disabled-opacity common-action-items-text-grey" : "common-action-items-text-red"}`}
      >
        Delete Campaign
      </span>
    </div>
  );

  const addProductButton = (
    <div
      className={`campaign-overview-actions ${
        campaignInfo?.status == 600 ||
        hideButton ||
        offerTooltip ||
        campaignInfo?.status == 700 ||
        campaignInfo?.status === 800 ||
        campaignInfo?.status === 1000 ||
        campaignInfo?.status === 1200
          ? "disable-button"
          : "pointer"
      }`}
      onClick={() => {
        if (
          !(
            campaignInfo?.status === 600 ||
            hideButton ||
            offerTooltip ||
            campaignInfo?.status === 800 ||
            campaignInfo?.status === 1000 ||
            campaignInfo?.status === 1200
          )
        )
          handleAddCampaign();
      }}
    >
      <AddProduct
        className="campaign-action-icons"
        style={{
          color:
            campaignInfo?.status == 600 ||
            hideButton ||
            offerTooltip ||
            campaignInfo?.status == 700 ||
            campaignInfo?.status === 800 ||
            campaignInfo?.status === 1000 ||
            campaignInfo?.status === 1200
              ? "#808080"
              : "#d2042d",
        }}
      />
      <span className="campaign-overview-actions-headers common-action-items-text-grey">
        Add Product
      </span>
    </div>
  );

  const addtoCartText =
    campaignInfo?.added_to_cart == 1 ? "Added to Cart " : "Add to Cart";
  const isAddToCartDisabled =
    hideButton ||
    offerTooltip ||
    campaignInfo?.added_to_cart == 1 ||
    !campaignInfo?.products ||
    campaignInfo?.status > 100;
  const mobileAddToCart = (
    <div
      className={`add-to-cart redesigned-add-cart ${
        isAddToCartDisabled ? "disable-button" : "pointer default-color"
      }`}
      onClick={isAddToCartDisabled ? undefined : handleAddtoCart}
    >
      <CartIcon
        className="campaign-icons re-export-button-size"
        style={{ marginRight: "0.5rem" }}
      />
      <span className="common-text-white-13">{addtoCartText}</span>
    </div>
  );

  const exportExcel = (campaignDetails) => {
    if (campaignDetails?.products) {
      sessionStorage.setItem(
        "products",
        JSON.stringify(campaignDetails?.products),
      );
      sessionStorage.setItem("campaignCid", campaignDetails?.cid);
    }
    navigate(
      `/buyer/campaigndetails/export-data?_id=${btoa(campaignDetails?.id)}`,
      { state: campaignDetails },
    );
  };

  return (
    <div className="campaign-overview common-card-styles">
      <div className="re-designed-campaign-verview-container">
        <p className="campaign-overview-value common-sub-header-black-14">
          Campaign Overview
        </p>

        <div
          className="campaign-overview-section"
          style={{ marginBottom: isMobile ? 0 : "1.81rem" }}
        >
          <div className="campaign-overview-sub-section">
            <span className="campaign-overview-header common-data-labels-grey">
              Campaign Name
            </span>
            <div className="product-copy-text-field">
              <Tooltip title={campaignInfo?.name}>
                <span className="campaign-overview-value truncate common-data-value-black">
                  {campaignInfo?.name || "-"}
                </span>
              </Tooltip>
              <CopyOutlined
                onClick={(e) => {
                  e.stopPropagation(); // prevent tooltip close
                  handleCopy(campaignInfo?.name);
                }}
                className="copy-icon"
              />
            </div>
          </div>

          <div className="campaign-overview-sub-section">
            <span className="campaign-overview-header common-data-labels-grey">
              Campaign ID
            </span>
            <div className="product-copy-text-field">
              <span className="campaign-overview-value common-data-value-black">
                {campaignInfo?.cid || "-"}
              </span>
              <CopyOutlined
                onClick={(e) => {
                  e.stopPropagation(); // prevent tooltip close
                  handleCopy(campaignInfo?.cid);
                }}
                className="copy-icon"
              />
            </div>
          </div>
        </div>
        <div
          className="campaign-overview-section"
          style={{ marginBottom: "1.81rem" }}
        >
          <div className="campaign-overview-sub-section">
            <span className="campaign-overview-header common-data-labels-grey">
              Duration
            </span>
            <div className="campaign-overview-sub-section-sub-div">
              <span className="campaign-overview-value common-data-value-black">
                {formatDate(campaignInfo?.startDate) || "-"}
              </span>
              <Arrow
                className="campaign-icons campaign-overview-icons"
                style={{ width: "16px", height: "16px" }}
              />
              <span className="campaign-overview-value common-data-value-black">
                {formatDate(campaignInfo?.endDate) || "-"}
              </span>
            </div>
          </div>

          <div className="campaign-overview-sub-section">
            <span className="campaign-overview-header common-data-labels-grey">
              No. of Products
            </span>
            <span className="campaign-overview-value common-data-value-black">
              {campaignInfo?.products?.length || "-"}
            </span>
          </div>
        </div>

        {isMobile && (
          <>
            <div className="campaigns-buttons-div">
              <Button
                className="campaign-export-btn re-designed-export-btn"
                onClick={() => exportExcel(campaignInfo)}
              >
                {/* <ExcelIcon className="re-export-button-size" /> */}
                <Text className="excel-export common-text-color-black-13">
                  Export
                </Text>
              </Button>
              {hideButton || offerTooltip ? (
                <Tooltip
                  title={getToolTipContent}
                  onTouchStart={getToolTipContent}
                >
                  {mobileAddToCart}
                </Tooltip>
              ) : (
                <> {mobileAddToCart} </>
              )}
            </div>
            <Outlet />
          </>
        )}
      </div>

      {!isMobile && (
        <>
          <div className="common-divider-horizontal" />
          <Row
            gutter={[12, 12]}
            className="campaign-more-actions-div campaign-overview-more-actions-div"
          >
            <Col className="campaign-overview-actions-container">
              <div className="campaign-overview-actions-sub-container">
                <div
                  className="campaign-overview-actions pointer"
                  onClick={handleShareCampaign}
                >
                  <Share className="campaign-action-icons " />
                  <span className="campaign-overview-actions-headers common-action-items-text-grey">
                    Share
                  </span>
                </div>
                <Divider type="vertical" className="divider" />
              </div>
            </Col>
            <Col className="campaign-overview-actions-container">
              <div className="campaign-overview-actions-sub-container">
                {(() => {
                  const tooltipContent = getToolTipContent?.();
                  const shouldShowTooltip =
                    (hideButton ||
                      offerTooltip ||
                      campaignInfo?.status == 600 ||
                      campaignInfo?.checkout_checked == 1 ||
                      campaignInfo?.status == 700) &&
                    tooltipContent !==
                      "You cannot perform this action, when it is already in cart";
                  return shouldShowTooltip ? (
                    <Tooltip title={tooltipContent}>{addProductButton}</Tooltip>
                  ) : (
                    <>{addProductButton}</>
                  );
                })()}

                <Divider type="vertical" className="divider" />
              </div>
            </Col>
            <Col className="gutter-row">
              <div className="campaign-overview-actions-sub-container">
                <div
                  className="campaign-overview-actions pointer"
                  onClick={handleDuplicateCampaign}
                >
                  <Duplicate className="campaign-action-icons" />
                  <span className="campaign-overview-actions-headers common-action-items-text-grey">
                    Duplicate Campaign
                  </span>
                </div>
                <Divider type="vertical" className="divider" />
              </div>
            </Col>
            <Col className="gutter-row">
              {hideButton ||
              offerTooltip ||
              campaignInfo?.status == 600 ||
              campaignInfo?.checkout_checked == 1 ||
              campaignInfo?.status == 700 ? (
                <Tooltip title={getToolTipContent}>
                  {deleteCampaignButton}
                </Tooltip>
              ) : (
                <>{deleteCampaignButton}</>
              )}
            </Col>
            <Modal
              open={shareCampaign}
              footer={false}
              width={558}
              height={469}
              closable={false}
              centered
            >
              <ShareCampaign
                shareCampaign={shareCampaign}
                setShareCampaign={setShareCampaign}
                campaignId={campaignInfo?.id}
              />
            </Modal>
            <Modal
              open={duplicateCampaign}
              footer={false}
              width={558}
              height={260}
              closable={false}
              centered
            >
              <DuplicateCampaign
                campaignName={campaignInfo?.name}
                duplicateEntireCampaign={duplicateCampaign}
                campaignId={campaignInfo?.id}
                setDuplicateEntireCampaign={setDuplicateCampaign}
              />
            </Modal>
            <DeleteCamapign
              setDeleteCampaignModal={setDeleteCampaignModal}
              deleteCampaignModal={deleteCampaignModal}
              deleteCampaignId={campaignInfo?.id}
            />
          </Row>
        </>
      )}

      <Drawer
        size="default"
        placement="bottom"
        closable={false}
        onClose={() => setMenu(false)}
        open={menu}
        onClick={() => setMenu(false)}
      >
        <div className="campaigns-overview-drawer-div">
          <Space direction="vertical" size={20}>
            <Row onClick={handleQoute}>
              <Text className="campaign-details-action-items">View Quote</Text>
            </Row>
            <Row
              onClick={() => {
                if (restrictOfferClick()) {
                  return;
                } else {
                  handleOfferModal();
                }
              }}
              className={` ${restrictOfferClick() ? "disable-button" : "pointer"}`}
            >
              <Text className="campaign-details-action-items"> Offer</Text>
            </Row>
            <Row onClick={handleIO}>
              <Text className="campaign-details-action-items">View IO</Text>
            </Row>
            <Row
              onClick={() => {
                if (restrictClick()) {
                  return;
                } else {
                  handleGrossFee();
                }
              }}
              className={` ${restrictClick() ? "disable-button" : "pointer"}`}
            >
              <Text className="campaign-details-action-items">Gross Fees</Text>
            </Row>
            {campaignInfo?.cmp_type === 1 && (
              <>
                <Row onClick={handleViewRfp}>
                  <Text className="campaign-details-action-items">
                    View RFP
                  </Text>
                </Row>
              </>
            )}
            {userInfo?.email == "richard.advertisingmarketplace@gmail.com" && (
              <Row>
                <Text
                  className="campaign-details-action-items"
                  onClick={() => {
                    setTransferCampaignFlag(true);
                  }}
                >
                  Transfer Campaign
                </Text>
              </Row>
            )}
            {/* {campaignInfo?.status > 100 &&
              campaignInfo?.campaign_terms_array?.length > 0 && (
                <Row onClick={handleTermsHistory}>
                  <Text className="campaign-details-action-items">
                    Terms Plan
                  </Text>
                </Row>
              )} */}
          </Space>
        </div>
      </Drawer>
      <ViewTermsPlan
        setViewTermsModal={setViewTermsModal}
        viewTermsModal={viewTermsModal}
        campaignTermsArray={campaignInfo?.campaign_terms_array}
      />
    </div>
  );
};
export default CampaignOverview;
